import React from 'react';
import PropTypes from 'prop-types';
import TransactionDetails from '../../common/TransactionDetalis';
import {
  TRANSACTION_DETAILS_GS_QUERY,
  FRAUD_TRANSACTION_DETAILS_GS_QUERY
} from './constant';
import { TM_FRAUD_SOURCE_STRINGS } from '../../../util/GlobalConstant';

const TransactionDetailsTab = ({ settings, alertId, sourceId, ...props }) => (
  <TransactionDetails
    settings={settings}
    alertId={alertId}
    gsQuery={
      sourceId && sourceId === TM_FRAUD_SOURCE_STRINGS.FRAUDIAD
        ? FRAUD_TRANSACTION_DETAILS_GS_QUERY
        : TRANSACTION_DETAILS_GS_QUERY
    }
    {...props}
  />
);

TransactionDetailsTab.propTypes = {
  settings: PropTypes.object,
  alertId: PropTypes.string.isRequired
};

export default TransactionDetailsTab;
